// Thin fetch wrapper for the museumx backend admin API (/api/admin/*).
//
// REACT_APP_API_BASE is baked in per deploy mode:
//   local         -> http://localhost:3000   (cross-origin, backend CORS open)
//   server-ip     -> ""                       (same origin, nginx proxies /api)
//   server-domain -> https://backend.<domain> (cross-origin, backend CORS open)

const API_BASE = (process.env.REACT_APP_API_BASE || "").replace(/\/+$/, "");
const TOKEN_KEY = "museumx_admin_token";

export function getToken() {
  try { return localStorage.getItem(TOKEN_KEY) || ""; } catch { return ""; }
}
export function setToken(t) {
  try { localStorage.setItem(TOKEN_KEY, t); } catch {}
}
export function clearToken() {
  try { localStorage.removeItem(TOKEN_KEY); } catch {}
}

/**
 * Authenticated JSON fetch. Pass `headers: { Authorization: "" }` to force an
 * unauthenticated request (used by login so a stale token is never sent).
 */
export async function apiFetch(path, options = {}) {
  const headers = { "Content-Type": "application/json", ...(options.headers || {}) };

  if (!("Authorization" in headers)) {
    const token = getToken();
    if (token) headers.Authorization = `Bearer ${token}`;
  }
  if (headers.Authorization === "") delete headers.Authorization;

  const res = await fetch(`${API_BASE}${path}`, { ...options, headers });
  const data = await res.json().catch(() => ({}));

  if (!res.ok) {
    // Expired/invalid token: drop it so a reload bounces to /login.
    if (res.status === 401) clearToken();
    throw new Error(data?.error || `HTTP ${res.status}`);
  }
  return data;
}
